import BaseService from './BaseService';
import { API_ENDPOINTS } from '../constants';

class IdeaService {
  async getIdeas(params = {}) {
    const response = await BaseService.get(API_ENDPOINTS.IDEAS.LIST, params, { useCache: false });
    // Return the full response with ideas and pagination
    return {
      ideas: response?.data?.ideas || [],
      pagination: response?.data?.pagination || {}
    };
  }

  async getIdeaById(id) {
    const response = await BaseService.get(API_ENDPOINTS.IDEAS.BY_ID(id));
    console.log('IdeaService.getIdeaById response:', response);
    // Handle both response structures
    if (response?.data?.idea) {
      return response.data.idea;
    }
    if (response?.idea) {
      return response.idea;
    }
    return null;
  }

  async getCategories() {
    const response = await BaseService.get(API_ENDPOINTS.IDEAS.CATEGORIES, {}, { useCache: true });
    // Extract categories from response.data.categories
    return response?.data?.categories || [];
  }

  async getHeatingTypes() {
    const response = await BaseService.get(API_ENDPOINTS.IDEAS.HEATING_TYPES, {}, { useCache: true });
    // Extract heating types from response.data.heatingTypes
    return response?.data?.heatingTypes || [];
  }

  async getSizeRanges() {
    return BaseService.get(API_ENDPOINTS.IDEAS.SIZE_RANGES, {}, { useCache: true });
  }

  async getFeaturedIdeas(params = {}) {
    return BaseService.get(API_ENDPOINTS.IDEAS.FEATURED, params);
  }

  async getPopularIdeas(params = {}) {
    return BaseService.get(API_ENDPOINTS.IDEAS.POPULAR, params);
  }

  async searchIdeas(query, params = {}) {
    return BaseService.get(API_ENDPOINTS.IDEAS.SEARCH, { q: query, ...params });
  }

  async incrementViewCount(id) {
    return BaseService.post(API_ENDPOINTS.IDEAS.VIEW(id));
  }

  async purchaseIdea(id) {
    return BaseService.post(API_ENDPOINTS.IDEAS.PURCHASE(id));
  }

  async toggleLike(id) {
    return BaseService.post(API_ENDPOINTS.IDEAS.TOGGLE_LIKE(id));
  }

  async createIdea(data) {
    return BaseService.post(API_ENDPOINTS.IDEAS.CREATE, data);
  }

  async updateIdea(id, data) {
    console.log('IdeaService.updateIdea called with:', { id, data });
    const response = await BaseService.put(API_ENDPOINTS.IDEAS.UPDATE(id), data);
    console.log('IdeaService.updateIdea response:', response);
    return response;
  }

  async deleteIdea(id) {
    return BaseService.delete(API_ENDPOINTS.IDEAS.DELETE(id));
  }

  async toggleFeatured(id) {
    return BaseService.patch(API_ENDPOINTS.IDEAS.TOGGLE_FEATURED(id));
  }

  async createCategory(data) {
    return BaseService.post(API_ENDPOINTS.IDEAS.CREATE_CATEGORY, data);
  }

  async updateCategory(id, data) {
    return BaseService.put(API_ENDPOINTS.IDEAS.UPDATE_CATEGORY(id), data);
  }

  async deleteCategory(id) {
    return BaseService.delete(API_ENDPOINTS.IDEAS.DELETE_CATEGORY(id));
  }

  async createHeatingType(data) {
    return BaseService.post(API_ENDPOINTS.IDEAS.CREATE_HEATING_TYPE, data);
  }

  async updateHeatingType(id, data) {
    return BaseService.put(API_ENDPOINTS.IDEAS.UPDATE_HEATING_TYPE(id), data);
  }

  async deleteHeatingType(id) {
    return BaseService.delete(API_ENDPOINTS.IDEAS.DELETE_HEATING_TYPE(id));
  }
}

export default new IdeaService();
